import { render, staticRenderFns } from "./SimilarLotListComponent.vue?vue&type=template&id=57898e30&scoped=true&"
import script from "./SimilarLotListComponent.vue?vue&type=script&lang=js&"
export * from "./SimilarLotListComponent.vue?vue&type=script&lang=js&"
import style0 from "./SimilarLotListComponent.vue?vue&type=style&index=0&id=57898e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57898e30",
  null
  
)

export default component.exports